<template>
  <v-treeview
    disable-resize-watcher="true"
    style="cursor: pointer; width: 100%"
    :items="getTree"
    :active.sync="treeActive"
    :open.sync="$store.state.structure.settings.treeOpen"
    loading-icon="autorenew"
    expand-icon="expand_more"
    active-class="active"
    class="caption font-weight-medium font-condensend"
    item-disabled="disabled"
    activatable
    open-on-click
    :multiple-active="false"
    item-key="id"
    return-object
  >

    <template v-slot:label="{ item, open, active }" :data-testid="$options.name + '__template__' + item.name">
      <v-layout fill-height align-center class="treeLeaf">
        <span class="body-1 font-weight-medium font-condensend px-2">{{
          $t(item.name)
        }}</span>
      </v-layout>
    </template>

  </v-treeview>
</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface TreeNode {
  id: string
  name?: string
  children?: TreeNode[]
  [key: string]: any
}

interface TreeActiveItem {
  id?: string
  [key: string]: any
}

interface StructureState {
  settings: {
    tree: TreeNode[]
    treeActive: TreeActiveItem[]
  }
}

interface RootState {
  structure: StructureState
}

interface CurrentUser {
  role?: 'administrator' | 'manager' | 'operator' | 'inform_secur_user'
  [key: string]: any
}

interface RoleFilter {
  administrator: string[]
  manager: string[]
  operator: string[]
  inform_secur_user: string[]
}

export default Vue.extend({
  name: 'CONFIGURATION_TREE',

  components: {},

  props: {},

  data(): {
    currentActive: TreeActiveItem | null
  } {
    return {
      currentActive: null,
    }
  },

  computed: {
    getTree(): TreeNode[] {
      const state = this.$store.state as unknown as RootState
      const tree = state.structure.settings.tree

      if (!this.getCurrentUser) {
        return tree
      }

      const filter: RoleFilter = {
        administrator: [],
        manager: ['users', 'maintenance'],
        operator: [],
        inform_secur_user: []
      }

      const userRole = this.getCurrentUser.role
      const excludedIds = filter[userRole as keyof RoleFilter] || []

      return tree.filter(page => !excludedIds.includes(page.id))
    },

    treeActive: {
      get(): TreeActiveItem[] {
        const state = this.$store.state as unknown as RootState
        return state.structure.settings.treeActive
      },
      set(newVal: TreeActiveItem[]): void {
        if (!newVal?.length) {
          if (this.currentActive?.id) {
            this.$nextTick(() => {
              this.$set((this.$store.state as unknown as RootState).structure.settings, 'treeActive', [this.currentActive])
            })
          }
          return
        }

        if (Array.isArray(newVal) && newVal.length) {
          if (newVal[0].id === this.currentActive?.id) {
            return
          }
          if (!this.currentActive) {
            this.currentActive = newVal[0]
          }
        }

        this.$set((this.$store.state as unknown as RootState).structure.settings, 'treeActive', newVal)
        this.currentActive = newVal[0]
      },
    },

    getCurrentUser(): CurrentUser | null {
      return this.$store.getters.getCurrentUser
    },
  },

  async created(): Promise<void> {
    this.setup()
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },

    async testMethod(item: any): Promise<void> {
      // Метод предназначен для переопределения при необходимости
    },
  },
})
</script>

<style lang="css" scoped>
.activeElement{
  border-radius: 14px;
}

.treeLeaf{
  height: 38px;
}

</style>
